import axios from "@/axios";
import {Module} from "vuex";
import {sortByName} from "@/utils/sortGeography";

const state = () => ({
    towns: [],
    blogTowns: []
});

const getters = {
    getTowns(state: any){
        return state.towns;
    },
    getBlogTowns(state: any) {
        return state.blogTowns
    }
};
const actions = {
    async fetchTowns({commit}: any, regionId: any){
        const response = await axios.get('/town/'+regionId);
        commit('saveTowns', response.data);
    },
    async fetchBlogTowns({commit}: any, regionId: any){
        const response = await axios.get('/blog/town/'+regionId);
        commit('saveBlogTowns', response.data);
    }
};
const mutations = {
    saveTowns(state: any, payload: any){
        state.towns = sortByName(payload);
        localStorage.setItem('towns',JSON.stringify(state.towns))
    },
    saveBlogTowns(state: any, payload: any){
        state.blogTowns = payload;
        localStorage.setItem('blogTowns',JSON.stringify(state.blogTowns))
    }
};

export const towns: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
